import React, { useEffect, useState } from "react";
import "./FaqModal.css";
import Button from "../../../../components/reusable-button/Button";
import Switch from "../../../../components/reusable-switch/Switch";
import CustomEditor from "../../../../components/custom-textEditor/CustomEditor";

export interface FaqFormData {
  id?: string;
  question: string;
  answer: string;
  active: boolean;
}

interface FaqModalProps {
  isOpen: boolean;
  mode: "add" | "edit";
  onClose: () => void;
  onSave: (data: FaqFormData) => void;
  initialData?: FaqFormData;
  loading?: boolean;
}

const FaqModal: React.FC<FaqModalProps> = ({
  isOpen,
  mode,
  onClose,
  onSave,
  initialData,
  loading = false,
}) => {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [active, setActive] = useState(true);

  useEffect(() => {
    if (initialData) {
      setQuestion(initialData.question);
      setAnswer(initialData.answer);
      setActive(initialData.active);
    }
  }, [initialData]);

  useEffect(() => {
    if (!isOpen) {
      setQuestion("");
      setAnswer("");
      setActive(true);
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({ question, answer, active });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="faq-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="faq-modal-title">
          {mode === "add" ? "Add FAQs" : "Edit FAQs"}
        </h2>

        <form className="faq-modal-body" onSubmit={handleSubmit}>
          <label className="input-label">
            Question <span className="required">*</span>
          </label>
          <textarea
            className="textarea"
            required
            placeholder="Enter Question Here"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            maxLength={200}
          />

          <label className="input-label">
            Answer <span className="required">*</span>
          </label>
          {/* <RichTextEditor value={answer} onChange={setAnswer} /> */}
          <CustomEditor value={answer} onChange={setAnswer} />
          {initialData && (
            <Switch
              label={active ? "Active" : "Inactive"}
              checked={active}
              onChange={() => setActive((prev) => !prev)}
            />
          )}

          <div className="faq-footer">
            <Button
              variant="outlined"
              label="Cancel"
              type="button"
              onClick={onClose}
            />
            <Button
              label={mode === "add" ? "Add Question" : "Update Question"}
              type="submit"
              loading={loading}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default FaqModal;
